import '@common/assets/styles/theme.css';
// import { AppProvider } from "@shopify/polaris";
// import "@shopify/polaris/build/esm/styles.css";
// import enTranslations from "@shopify/polaris/locales/en.json";
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './main.css';
import { router } from './router';


ReactDOM.createRoot(document.getElementById('root')!).render(
    <RouterProvider router={router} />
)
